import * as React from 'react';
import Cpvalue from '../../screens/Settings/Cpvalue';
import {connect} from 'react-redux';
import {fetchCpvalue, AddCpvalue} from './action';
class CpvalueContainer extends React.Component<Props, State> {
  render() {
    return (
      <Cpvalue
        fetchCpvalue={this.props.fetchCpvalue}
        AddCpvalue={this.props.AddCpvalue}
        CpvalueList={this.props.CpvalueList}
        // CpvalueDtlsCount={this.props.CpvalueList}
      />
    );
  }
}

function bindAction(dispatch) {
  return {
    fetchCpvalue: () => {
      console.log('=============================');
      dispatch(fetchCpvalue());
    },
    AddCpvalue: value => {
      console.log('===valuevaluevaluevalue ', value);
      dispatch(AddCpvalue(value));
    },
  };
}

function mapStateToProps(state) {
  console.log('@@@@@@@@@@@@@@@@@@@@@@@@@@', state.CpvalueReducer.CpvalueList);
  return {
    CpvalueList: state.CpvalueReducer.CpvalueList,
    // CpvalueDtlsCount: state.CpvalueReducer.CpvalueDtlsCount,
  };
}

export default connect(mapStateToProps, bindAction)(CpvalueContainer);
